import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import { getAuthConfig } from "./apiClient";

export const CONTACT_SERVICE_OPTIONS = [
  { id: "UI/UX", value: "UI/UX" },
  { id: "Mobile app development", value: "Mobile app development" },
  { id: "Web development", value: "Web development" },
  {
    id: "Search Engine Optimization (SEO)",
    value: "Search Engine Optimization (SEO)",
  },
  {
    id: "Social Media Marketing (SMM)",
    value: "Social Media Marketing (SMM)",
  },
  { id: "Internet of Things", value: "Internet of Things" },
  { id: "Other", value: "Other" },
];

export const submitContact = async ({
  name,
  serviceType,
  email,
  phoneNumber,
  projectDescription,
  meetingDate,
  meetingStartTime,
  meetingEndTime,
  meetingTimezone,
}) => {
  const payload = {
    name,
    serviceType,
    email,
    phoneNumber,
    projectDescription: projectDescription || undefined,
  };

  if (meetingDate && meetingStartTime && meetingEndTime) {
    payload.meetingDate = meetingDate;
    payload.meetingStartTime = meetingStartTime;
    payload.meetingEndTime = meetingEndTime;
    payload.meetingTimezone = meetingTimezone || undefined;
  }

  const response = await axios.post(`${API_BASE_URL}/contacts`, payload);

  return response.data;
};

export const fetchContactList = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/contacts`,
    getAuthConfig(),
  );

  return response.data?.items || [];
};
